import React, { useEffect, useState } from "react";
import presignedUrl from "js/config/s3Config";
import LoaderDiv from "./LoaderDiv";
import axios from "axios";
import { saveAs } from "file-saver";

function DownloadFile({ uuid, suffix, fileName }) {
  const [file, setFile] = useState(null);
  useEffect(() => {
    (async () => {
      if (uuid) {
        const file = await presignedUrl(`${uuid}.${suffix}`, "referrals/");
        setFile(file);
      }
    })();
  }, [uuid, suffix]);

  const downloadOnClick = async () => {
    const response = await axios.get(file, {
      responseType: "blob",
    });
    saveAs(response.data, fileName);
  };

  return file === null ? (
    <LoaderDiv />
  ) : (
    <button className="download-file" onClick={downloadOnClick}>
      <span className="file-name">{fileName}</span>
    </button>
  );
}

export default DownloadFile;
